import { render } from "./HomeFeatureRight.vue?vue&type=template&id=1224b72f&scoped=true"
import script from "./HomeFeatureRight.vue?vue&type=script&lang=js"
export * from "./HomeFeatureRight.vue?vue&type=script&lang=js"

import "./HomeFeatureRight.vue?vue&type=style&index=0&id=1224b72f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1224b72f"

export default script